module.exports = __webpack_public_path__ + "static/media/gamzix.6ced5a47.webp";